/* Cart-only recommendations reuse the same Shopify API as product-page upsells. */
window.rfCartPage = function (recommendationsEnabled) {
  const cache = new Map();
  let requestVersion = 0;
  let lastSignature = null;

  async function recommendations(productId, intent) {
    const key = `${productId}:${intent}`;
    if (!cache.has(key)) {
      cache.set(key, (async () => {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 8000);
        try {
          const root = window.Shopify.routes.root;
          const response = await fetch(`${root}recommendations/products.json?product_id=${productId}&limit=6&intent=${intent}`, { signal: controller.signal });
          if (!response.ok) return [];
          const data = await response.json();
          return Array.isArray(data.products) ? data.products : [];
        } catch {
          // A failed recommendation request must never interrupt cart or checkout.
          return [];
        } finally {
          clearTimeout(timer);
        }
      })());
    }
    return cache.get(key);
  }

  // Round-robin results so the first cart product does not occupy every slot.
  function collect(groups, excluded, selected) {
    const seen = new Set([...excluded, ...selected.map(product => Number(product.id))]);
    const length = Math.max(0, ...groups.map(group => group.length));
    for (let index = 0; index < length && selected.length < 6; index++) {
      for (const group of groups) {
        const product = group[index];
        if (product?.available && product.variants?.length && !seen.has(Number(product.id))) {
          seen.add(Number(product.id));
          selected.push(product);
          if (selected.length === 6) break;
        }
      }
    }
    return selected;
  }

  return {
    suggestedProducts: [],
    init() {
      if (!recommendationsEnabled) return;
      this.loadSuggestions(this.cart.items);
      this.$watch('cart.items', items => this.loadSuggestions(items));
    },
    async loadSuggestions(items) {
      const ids = [...new Set(items.map(item => Number(item.product_id)).filter(Number.isFinite))];
      const signature = ids.join(',');
      if (signature === lastSignature) return;
      lastSignature = signature;
      const version = ++requestVersion;
      this.suggestedProducts = this.suggestedProducts.filter(product => !ids.includes(Number(product.id)));
      if (!ids.length) {
        this.suggestedProducts = [];
        return;
      }
      // Bound network work for large carts. All cart IDs still participate in exclusions.
      const seeds = ids.slice(0, 4);
      const excluded = new Set(ids);
      const complementary = await Promise.all(seeds.map(id => recommendations(id, 'complementary')));
      const selected = collect(complementary, excluded, []);
      if (selected.length < 6) {
        const related = await Promise.all(seeds.map(id => recommendations(id, 'related')));
        collect(related, excluded, selected);
      }
      if (version === requestVersion) this.suggestedProducts = selected;
    }
  };
};
